import { render, staticRenderFns } from "./showAgreeMemo.vue?vue&type=template&id=51c5b484&scoped=true&"
import script from "./showAgreeMemo.vue?vue&type=script&lang=js&"
export * from "./showAgreeMemo.vue?vue&type=script&lang=js&"
import style0 from "./showAgreeMemo.vue?vue&type=style&index=0&id=51c5b484&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5b484",
  null
  
)

export default component.exports